import { resizable } from 'views/mixins/index'

/**
 Mixin for all components which use a Mapbox
 *
 * Provides shortcut properties and methods
 */
export default {

  computed: {
    $map () {
      return this.$refs.map
    },
    map () {
      return this.$map.map
    },
    popup () {
      return this.$map.popup
    }
  }
}